export default __webpack_public_path__ + "static/media/logoWhite.6a08257b.jpg";